import JourneyMapModal from './styled';

export default JourneyMapModal;
